import React from 'react';
import { SearchInput, SearchFormStyled, SearchIcon} from "./searchInput.style"

const SearchForm = () => (
    
    <SearchFormStyled action="search/" method="get">
        <label htmlFor="header-search">
            <span className="visually-hidden"></span>
        </label>
        <SearchInput
            type="text"
            id="header-search"
            name="q" 
        />
        <SearchIcon type="submit">Search</SearchIcon>
    </SearchFormStyled>
);

export default SearchForm;